import { ANALYTICS_EVENTS } from '../events'
import createAnalyticsStatic, { EventProps } from './createAnalyticsEvent'

export type OnboardingKycResultFailedProps = EventProps

/**
 * @event onboarding_kyc_result_failed
 * @description Emitted when the FrankieOne KYC verification fails.
 */
export const OnboardingKycResultFailedAnalytics = createAnalyticsStatic<OnboardingKycResultFailedProps>(
    ANALYTICS_EVENTS.ONBOARDING.ONBOARDING_KYC_RESULT_FAILED,
)

export default OnboardingKycResultFailedAnalytics
